import React from 'react';

import { InsightRecommendation, InsightRecommendationProps } from './insight-recommendation';
import * as styles from './insight-recommendation.scss';

interface InsightRecommendationsProps {
  recommendations: InsightRecommendationProps[];
}

export const InsightRecommendations = ({ recommendations }: InsightRecommendationsProps) => {
  return (
    <div className={styles.recommendationsList}>
      {recommendations.map((recommendation, index) => (
        <InsightRecommendation key={index} {...recommendation} />
      ))}
    </div>
  );
};
